// extracted by mini-css-extract-plugin
module.exports = {"button3":"CategoryRead_button3__1ZbLL","selectCategory":"CategoryRead_selectCategory__-pkzG","label":"CategoryRead_label__2tcwc","General":"CategoryRead_General__3nOJ2"};